module.exports = __webpack_public_path__ + "img/Maradona-4.15d4066d.webp";